module.exports = __webpack_public_path__ + "static/media/file-music.d890e3f0.svg";